<template>
    <div>
        <!-- <ImageSphereAnimation/> -->
    </div>
</template>


<script>
import {mapGetters} from 'vuex';
import ImageSphereAnimation from "@/components/flux360/CustomSituations/ImageSphereAnimation.vue";

export default {
    components: {ImageSphereAnimation},
    computed: {
        ...mapGetters(['currentSituationID']),
    },
}
</script>

<style>
    
</style>